import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import { routes } from "./const";
import Dashboard from "./pages/Dashboard";
import Intro from "./pages/Intro";
import TaskSelection from "./pages/TaskSelection";
import TaskCompletion from "./pages/TaskCompletion";
import PostSurvey from "./pages/PostSurvey";
import Thankyou from "./pages/Thankyou";
import NotFound from "./pages/NotFound";
import Task from "./pages/Task";
import Subtask from "./pages/Subtask";
import CoordFinder from "./components/emulator/CoordFinder";

function App() {
  return (
    // <div className="w-96">
    <BrowserRouter>
      <Routes>
        <Route path={routes.DASHBOARD} element={<Dashboard/>}/>
        <Route path={routes.INTRO} element={<Intro/>}/>
        <Route path={routes.TASK_SELECTION} element={<TaskSelection/>}/>

        <Route path={routes.TASK} element={<Task />}/>
        <Route path={routes.SUBTASK} element={<Subtask />}/> 

        <Route path={routes.COMPLETION} element={<TaskCompletion />} />
        <Route path={routes.POST_SURVEY} element={<PostSurvey />} />
        <Route path={routes.NOT_FOUND} element={<NotFound />} />
        <Route path={routes.FIN} element={<Thankyou />} />

        <Route path={routes.COORDFINDER} element={<CoordFinder />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    // </div>
    
  );

}

export default App;
